"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = _interopRequireDefault(require("underscore"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _KeyboardUtils = _interopRequireWildcard(require("../../util/KeyboardUtils"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @enum {string}
 * @alias Anchor.linkTypes
 */
var linkTypes = {
  /** regular */
  REGULAR: "regular",

  /** add */
  ADD: "add",

  /** remove */
  REMOVE: "remove",

  /** pageReturn */
  PAGE_RETURN: "pageReturn",

  /** block */
  BLOCK: "block"
};
/**
 * @enum {string}
 * @alias Anchor.linkSizes
 */

var linkSizes = {
  /** auto */
  AUTO: "auto",

  /** sm */
  SM: "sm",

  /** md */
  MD: "md"
};
/**
 * @class Anchor
 * @desc An accessible link that can supports keyboard interaction even when no href is set.
 *
 * @param {string} [className]
 *     CSS classes to be set on the root element.
 * @property {string} [data-id]
 *     To define the base "data-id" value for the top-level HTML container.
 * @property {boolean} [disabled=false]
 *     Disables the link.
 * @param {function} [onClick]
 *     Callback to be triggered when trigger is clicked.
 * @param {Anchor.linkSizes} [size=AUTO]
 *     Size of link. When AUTO, the size is determined by context.
 * @param {Anchor.linkTypes} [type=REGULAR]
 *     Type of link
 * @param {boolean} [disabled=false]
 *     Indicates whether component is disabled.
 * @param {function} [onClick]
 *     Callback to be triggered when trigger is clicked.
 */

var AnchorBase = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AnchorBase, _React$Component);

  var _super = _createSuper(AnchorBase);

  function AnchorBase() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, AnchorBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleKeyPress", function (e) {
      if (e.charCode === _KeyboardUtils.default.KeyCodes.ENTER || e.charCode === _KeyboardUtils.default.KeyCodes.SPACE) {
        _this.props.onClick(e);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_typeIcon", function (type) {
      switch (type) {
        case linkTypes.ADD:
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "icon-plus anchor__icon"
          });

        case linkTypes.REMOVE:
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "icon-clear anchor__icon"
          });

        case linkTypes.PAGE_RETURN:
        case linkTypes.BLOCK:
        default:
          return null;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _classnames;

      var _this$props = _this.props,
          children = _this$props.children,
          className = _this$props.className,
          size = _this$props.size,
          type = _this$props.type,
          disabled = _this$props.disabled,
          iconAfter = _this$props.iconAfter,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "size", "type", "disabled", "iconAfter"]);
      return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
        tabIndex: "0"
      }, props, {
        className: (0, _classnames2.default)("anchor", className, (_classnames = {
          "page-return-link": type === linkTypes.PAGE_RETURN
        }, (0, _defineProperty2.default)(_classnames, "anchor--".concat(size), size !== linkSizes.AUTO), (0, _defineProperty2.default)(_classnames, "anchor--disabled", disabled), _classnames)),
        onKeyPress: _this._handleKeyPress
      }), _this._typeIcon(type), children);
    });
    return _this;
  }

  return AnchorBase;
}(_react.default.Component);

(0, _defineProperty2.default)(AnchorBase, "propTypes", {
  children: _propTypes.default.node,
  "data-id": _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  size: _propTypes.default.oneOf((0, _values.default)(linkSizes)),
  type: _propTypes.default.oneOf((0, _values.default)(linkTypes))
});
(0, _defineProperty2.default)(AnchorBase, "defaultProps", {
  "data-id": "anchor",
  disabled: false,
  onClick: _underscore.default.noop,
  type: "block"
});
var Anchor = (0, _KeyboardUtils.withFocusOutline)(AnchorBase);
Anchor.linkTypes = linkTypes;
Anchor.linkSizes = linkSizes;
var _default = Anchor;
exports.default = _default;
module.exports = exports["default"];